<template>
  <v-app>
    <v-container fluid grid-list-lg>
      <v-card>
        <v-app-bar flat>
          <v-icon>business_center</v-icon>
          <v-toolbar-title class="font-weight-light"
            >&nbsp;ABM de Empleadores</v-toolbar-title
          >
          <v-spacer></v-spacer>
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn
                text
                icon
                color="red"
                v-on="on"
                @click="setStatusTareaFrecuente(action)">
                <v-icon v-if="action.esFrecuente">favorite</v-icon>
                <v-icon v-else>favorite_border</v-icon>
              </v-btn>
            </template>
            <span v-if="action.esFrecuente">Quitar de Tareas Frecuentes</span>
            <span v-else>Agregar a Tareas Frecuentes</span>
          </v-tooltip>
        </v-app-bar>
        <v-card-text>
          <v-layout wrap>
            <v-flex xs12 sm6 md6 lg6>
              <v-card>
                <v-app-bar
                  flat
                  dense
                  :color="$store.state.UiColors.crudToolbarList">
                  <v-icon>list</v-icon>
                  <v-toolbar-title class="font-weight-light"
                    >Lista</v-toolbar-title
                  >
                  <v-spacer></v-spacer>
                </v-app-bar>

                <v-flex right>
                  <v-radio-group v-model="campo" row :mandatory="true">
                    <v-radio value="Nombre" label="Buscar por Nombre"></v-radio>
                    <v-radio value="CUIT" label="Buscar por CUIT"></v-radio>
                  </v-radio-group>

                  <v-text-field
                    v-model="search"
                    append-icon="search"
                    label="Buscar "
                    single-line
                    hide-details
                    @click:append="getItems()"></v-text-field>
                </v-flex>

                <v-data-table
                  :headers="headers"
                  :items="records"
                  :server-items-length="totalItems"
                  :loading="loading"
                  :options.sync="options"
                  v-model="selectedRow"
                  :footer-props="{
                    itemsPerPageOptions: options.rowsPerPageItems,
                  }">
                  <template slot="no-data">
                    <v-alert :value="true" color="grey" icon="warning">
                      No se encontraron datos
                    </v-alert>
                  </template>
                  <template v-slot:item="{ item }">
                    <tr @click="viewItem(item)">
                      <!-- <td class="text-xs-left">{{ item.tipoActividadLaboralDescripcion }}</td> -->
                      <td class="text-xs-left">{{ item.nombre }}</td>
                      <td class="text-xs-left">{{ item.cui }}</td>

                      <td class="text-xs-left">
                        <v-icon
                          small
                          class="mr-2"
                          @click="editItem(item)"
                          v-show="canUpdate"
                          >edit</v-icon
                        >
                        <v-icon
                          small
                          @click="deleteItem(item)"
                          v-show="canDelete"
                          >delete</v-icon
                        >
                      </td>
                    </tr>
                  </template>
                </v-data-table>
              </v-card>
            </v-flex>
            <v-flex xs12 sm6 md6 lg6>
              <v-card>
                <v-app-bar
                  flat
                  dense
                  :color="$store.state.UiColors.crudToolbarDetail">
                  <v-icon>business_center</v-icon>
                  <v-toolbar-title class="font-weight-light"
                    >Detalle</v-toolbar-title
                  >
                  <v-spacer></v-spacer>

                  <v-btn
                    v-if="!editMode"
                    :color="$store.state.UiColors.crudToolbarDetailButtons"
                    fab
                    small
                    top
                    @click="editItem()"
                    v-show="canCreate">
                    <v-icon medium>add_circle_outline</v-icon>
                  </v-btn>

                  <v-btn
                    :color="$store.state.UiColors.crudToolbarDetailButtons"
                    fab
                    small
                    top
                    @click="editMode = !editMode"
                    v-show="canUpdate">
                    <v-icon v-if="editMode">cancel</v-icon>
                    <v-icon v-else>edit</v-icon>
                  </v-btn>
                </v-app-bar>
                <v-card-text>
                  <v-form :disabled="!editMode">
                    <v-layout>
                      <v-flex xs6>
                        <v-text-field
                          v-model="model.nombre"
                          label="Nombre"
                          required
                          :disabled="!editMode"
                          v-validate="'required'"
                          data-vv-name="nombre"
                          :error-messages="
                            errors.collect('nombre')
                          "></v-text-field>
                      </v-flex>
                      <v-flex xs6>
                        <v-text-field
                          v-model="model.cui"
                          label="CUI"
                          required
                          :disabled="!editMode"
                          v-validate="'required'"
                          data-vv-name="cui"
                          :error-messages="
                            errors.collect('CUI')
                          "></v-text-field>
                      </v-flex>
                    </v-layout>

                    <v-layout>
                      <v-flex xs6>
                        <v-autocomplete
                          v-model="model.tipoActividadLaboralId"
                          :items="tiposActividadLaboral"
                          item-text="descripcion"
                          item-value="id"
                          label="Tipo de Actividad Laboral"
                          placeholder="Seleccione uno"
                          :disabled="!editMode"
                          :menu-props="{ minWidth: '400' }"></v-autocomplete>
                      </v-flex>
                      <v-flex xs6>
                        <v-autocomplete
                          v-model="model.diaCobroId"
                          :items="tiposDiaCobro"
                          item-text="descripcion"
                          item-value="id"
                          label="Día de cobro"
                          placeholder="Seleccione uno"
                          :disabled="!editMode"
                          :menu-props="{ minWidth: '400' }"></v-autocomplete>
                      </v-flex>
                    </v-layout>

                    <v-layout>
                      <v-flex>
                        <v-select
                          :items="listSituacionesLaboralesActividades"
                          v-model="model.tiposSituacionLaboralActividadId"
                          item-text="descripcion"
                          item-value="id"
                          label="Situaciones Laborales"
                          multiple
                          :disabled="!editMode"></v-select>
                      </v-flex>
                    </v-layout>

                    <v-layout>
                      <v-flex xs4>
                        <v-checkbox
                          v-model="activo"
                          label="Activo"
                          v-if="
                            model.id &&
                            model.id != '00000000-0000-0000-0000-000000000000'
                          "
                          :disabled="!editMode"
                          >>
                        </v-checkbox>
                      </v-flex>
                    </v-layout>

                    <v-divider></v-divider>
                    <template v-if="$store.state.debugModeOn">
                      Debug Info:
                      <p></p>

                      Model: {{ model }}
                      <p></p>
                    </template>
                    <v-divider></v-divider>

                    <v-card-actions bottom>
                      <!-- <v-speed-dial direction="right" >
                             <v-btn slot="activator" color="orange" text small v-show="editMode">
                                <v-icon color="orange">touch_app</v-icon>                                
                                Mas Acciones
                              </v-btn>
                              <v-tooltip bottom>
                                <v-btn small text color="green" slot="activator" @click="copiarDomicilio" v-show="editMode">
                                  Copiar Domicilio
                                </v-btn>
                                <v-btn small text color="green" slot="activator" @click="updateStatus" v-show="editMode">
                                    <v-text v-if="model.status.baja">Habilitar</v-text>
                                    <v-text v-else>Deshabilitar</v-text>
                                </v-btn>
                              </v-tooltip>
                            </v-speed-dial>
                             
                            <v-spacer></v-spacer> -->
                      <v-btn
                        color="success"
                        :disabled="!editMode"
                        @click="saveItem"
                        ><v-icon>save</v-icon>Guardar</v-btn
                      >
                    </v-card-actions>
                  </v-form>
                </v-card-text>
              </v-card>
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-card>
    </v-container>
  </v-app>
</template>

<script>
import { http } from "@/axios";
import Vue from "vue";
import { mapState, mapGetters, mapMutations, mapActions } from "vuex";

export default {
  data() {
    return {
      loading: false,
      editMode: false,
      suspend: false,
      search: "", // valor para búsqueda
      campo: "", //Define qué busca, si nombre o cuit
      options: {
        // definición de paginación
        sortDesc: [false],
        sortBy: [""],
        page: 1,
        itemsPerPage: 5,
        rowsPerPageItems: [5, 10, 20],
      },
      totalItems: 0, // va afuera de options
      headers: [
        // definición de columnas
        // { text: 'Actividad', value: 'tipoActividadLaboral' },
        { text: "Nombre", value: "nombre" },
        { text: "CUI", value: "cui" },
        { text: "Acciones", value: "name", sortable: false },
      ],
      activo: false,
      records: [], // registros
      selectedRow: [],
      listSituacionesLaboralesActividades: [],
      tiposActividadLaboral: [],
      tiposDiaCobro: [],
      model: { status: {} }, // registro para ver/editar
    };
  },
  async created() {
    this.loadTiposActividadLaboral();
    this.loadTiposDiaCobro();
    this.loadSituacionesLaboralesActividades();
  },
  watch: {
    options: {
      handler() {
        this.getItems();
      },
      deep: true,
    },
    // search() {
    //     this.getItems();
    // },
    "model.status"() {
      this.activo = !this.model.status.baja;
    },
  },
  computed: {
    ...mapGetters([
      "checkCanCreate",
      "checkCanUpdate",
      "checkCanDelete",
      "getActionFromLink",
    ]),
    canCreate: function () {
      return this.checkCanCreate(this.$route.path);
    },
    canUpdate: function () {
      return this.checkCanUpdate(this.$route.path);
    },
    canDelete: function () {
      return this.checkCanDelete(this.$route.path);
    },
    action: function () {
      return this.getActionFromLink(this.$route.path);
    },
  },
  methods: {
    ...mapMutations([
      "alertClear",
      "alertSuccess",
      "alertWarning",
      "alertError",
    ]),
    ...mapActions(["setStatusTareaFrecuente"]),
    async getItems() {
      this.loading = true;
      this.$validator.reset();

      try {
        var result = await http.get(
          "empleadores?valor=" +
            this.search +
            "&campo=" +
            this.campo +
            "&limit=" +
            this.options.itemsPerPage +
            "&page=" +
            this.options.page +
            "&sortby=" +
            this.options.sortBy +
            "&descending=" +
            (this.options.sortDesc.length > 0 ? this.options.sortDesc : "false")
        );

        this.records = result.list;
        this.totalItems = result.totalCount;
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },
    async resetState() {
      this.$validator.reset();
      this.editMode = false;
    },
    async getItem(id) {
      this.loading = true;
      this.resetState();

      try {
        var result = await http.get("empleadores/" + id);
        Vue.$log.debug(this.model);
        Vue.$log.debug(result);

        this.model = result;
      } catch (error) {
        // Error
        this.alertError(error);
      }

      this.loading = false;
    },
    async viewItem(item) {
      if (this.suspend) return;

      this.selectedRow.pop();
      this.selectedRow.push(item);

      await this.getItem(item.id);
      this.editMode = false;
    },
    async clearAndReload() {
      // Clear the data inside of the form
      this.model = { status: {} };
      this.resetState();

      // Refresco la grilla
      await this.getItems();
    },
    async editItem(item) {
      this.suspend = true; // hago esto porque se dispara también el evento click del row (que llama a viewItem)

      if (!item) await this.getItem("00000000-0000-0000-0000-000000000000");
      else await this.getItem(item.id);

      this.editMode = true;
      this.suspend = false;
    },
    async cancelEdit() {
      this.editMode = false;
    },
    async saveItem() {
      const isUpdate = this.model.id !== "00000000-0000-0000-0000-000000000000";

      await this.$validator.validateAll();

      if (this.errors.items.length > 0) return;

      if (isUpdate) {
        try {
          await http.put(
            "empleadores",
            JSON.stringify({ empleador: this.model })
          );
          this.alertSuccess("Los cambios han sido guardados.");
          this.clearAndReload();
        } catch (error) {
          Vue.$log.error(error);
          // Error
          this.alertError(error);
        }
      } else {
        try {
          await http.post(
            "empleadores",
            JSON.stringify({ empleador: this.model })
          );
          this.alertSuccess("Los cambios han sido guardados.");
          this.clearAndReload();
        } catch (error) {
          // Error
          Vue.$log.error(error);
          this.alertError(error);
        }
      }
    },
    async deleteItem(item) {
      Vue.$log.debug(item);
      if (
        confirm("¿Confirma la eliminación del empleador " + item.nombre + "?")
      ) {
        try {
          Vue.$log.debug(item);
          var result = await http.delete("empleadores?id=" + item.id);
          this.alertSuccess("El empleador ha sido eliminado.");
          this.clearAndReload();
        } catch (error) {
          // Error
          Vue.$log.error(error);
          this.alertError(error);
        }
      }
    },
    async loadTiposActividadLaboral() {
      this.loading = true;
      try {
        var result = await http.get("tiposactividadlaboral");
        this.tiposActividadLaboral = result.list;
      } catch (error) {
        // Error
        Vue.$log.error(error);
      }
      this.loading = false;
    },
    async loadTiposDiaCobro() {
      this.loading = true;
      try {
        var result = await http.get("tiposdiacobro");
        this.tiposDiaCobro = result.list;
      } catch (error) {
        // Error
        Vue.$log.error(error);
      }
      this.loading = false;
    },
    async loadSituacionesLaboralesActividades() {
      this.loading = true;
      try {
        var result = await http.get("situacioneslaborales/actividades");
        this.listSituacionesLaboralesActividades = result.list;
      } catch (error) {
        this.alertError(error);
      }
      this.loading = false;
    },
  },
};
</script>
